import React from 'react'
import WarningMessage from '../warning-message'

export default () => <WarningMessage>Redirecting you...</WarningMessage>
